/* eslint-disable import/prefer-default-export */
import { asyncActionType } from 'util/methods';

export const AdminTestItemTypes = {
  GET_ADMIN_TEST_ITEM_LIST: asyncActionType('GET_ADMIN_TEST_ITEM_LIST'),
  GET_ADMIN_TEST_ITEM_DETAIL: asyncActionType('GET_ADMIN_TEST_ITEM_DETAIL'),
  CREATE_ADMIN_TEST_ITEM_DETAIL: asyncActionType('CREATE_ADMIN_TEST_ITEM_DETAIL'),
  UPDATE_ADMIN_TEST_ITEM_DETAIL: asyncActionType('UPDATE_ADMIN_TEST_ITEM_DETAIL'),
  DELETE_ADMIN_TEST_ITEM_DETAIL: asyncActionType('DELETE_ADMIN_TEST_ITEM_DETAIL'),
  GET_CITATION_LIST: asyncActionType('GET_CITATION_LIST'),
  GET_ARCHIVE_LIST: asyncActionType('GET_ARCHIVE_LIST'),
  GET_TEST_ITEM_TYPE: asyncActionType('GET_TEST_ITEM_TYPE'),
  GET_TEST_ITEM_PRODUCTS: asyncActionType('GET_TEST_ITEM_PRODUCTS'),
  ARCHIVE_ADMIN_TEST_ITEM: asyncActionType('ARCHIVE_ADMIN_TEST_ITEM'),
  GET_TEST_LINE_LAB_OPTIONAL_LIST: asyncActionType('GET_TEST_LINE_LAB_OPTIONAL_LIST'),
};
